<!-- Use as template for other scorecards //-->
<template>
    <div>
        <!--
        Make sure the key is unique.
        api endpoint will be the part after "/api/private/scorecards/..."
        drill down rout is the "NAME" of the route in the router file.
        The style is the css class name for the section of scorecards to customize colors
        agent code will get passed from the view. Should come from url string or default to the current logged in user. 
        filters will come from the view as well... may or may not be used. 
        format can be "Currency" "Percentage" or don't pass anything for int. 
            //-->
        <q-score-card key="QScoreCardHqActiveStaff" title="Active Staff in HQ" :allow-refresh="true" api-endpoint="hq-active-staff" drill-downLabel="User Breakdown" drill-down-route="Drilldown_HQ_Active_Staff" card-style="hq-stats" :agent-code="agentCode" :filters="filtered_filters" :hide-goal="true">
            Note: Shows number of staff currently signed into HQ. If viewing under an agent, this would show how many users and "account grants" are currently signed in.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardHqActiveStaff",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {

    },
    computed: {
        filtered_filters: function() {
            return {
                statType: this.filters.statType
            }
        }
    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}
</script>
<style scoped>
</style>